import React, { useRef, useEffect } from 'react';
import * as S from '../FieldsDropdown/style';

interface SelectOptionsDropdownProps {
  options: { value: string; label: string }[];
  onSelect: (option: { value: string; label: string }) => void;
  close: () => void;
}

const SelectOptionsDropdown: React.FC<SelectOptionsDropdownProps> = ({
  options,
  onSelect,
  close,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        close();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [close]);

  return (
    <S.DropdownContainer ref={dropdownRef}>
      {options.map((option) => (
        <S.DropdownItem key={option.value} onClick={() => onSelect(option)}>
          {option.label}
        </S.DropdownItem>
      ))}
    </S.DropdownContainer>
  );
};

export default SelectOptionsDropdown;
